import React from 'react';
import {
    defineBlock,
    useEditor,
    useSmartProp,
    useInspectorControl,
    smartProps,
    EditableImg,
} from '@smartfire/gutenberg-react';
import { PanelBody, PanelRow, RangeControl } from '@wordpress/components';
import clsx from 'clsx';
import CloseIcon from '@material-ui/icons/Close';
import { useState } from 'react';
import style from './block.module.scss';
import ReactDOM from 'react-dom';

const Inspector = () => {
    const [width, setWidth] = useSmartProp('width');

    return (
        <PanelBody title="Configuration" initialOpen={true}>
            <PanelRow>
                <RangeControl
                    label="Largeur de l'image"
                    value={width}
                    onChange={(value) => setWidth(parseInt(value))}
                    min={0}
                    max={2000}
                    step={10}
                />
            </PanelRow>
        </PanelBody>
    );
};

const Block = ({ image, width = 500 }) => {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);
    const [isOpen, setOpen] = useState(false)

    const handleOpen = () => {
        setOpen(true)
        document.body.style.overflow = 'hidden';
        document.body.touchAction = 'none';
    }
    const handleClose = () => {
        document.body.style.overflow = 'auto';
        document.body.touchAction = 'auto';
        setOpen(false)
    }

    return (
        <div className={clsx(style.block)}>
            {isEditing ? (
                <EditableImg smartProp="image" style={{ width: width + 'px' }} />
            ) : (
                <div className={style.staticImage} >
                    <img src={image.url} alt={image.alt} style={{width: `${width}px`}} onClick={handleOpen} />
                    {isOpen && (
                        ReactDOM.createPortal(
                            <div className={style.modale}>
                                <button type="button" className={style.close} onClick={handleClose}>
                                    <CloseIcon />
                                </button>
                                <div className={style.modaleWrap} onClick={handleClose}>
                                    <img src={image.url} alt={image.alt} />
                                </div>
                            </div>,
                            document.querySelector('#page')
                        )
                    )}
                </div>
            )}
        </div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        image: smartProps.image,
        width: smartProps.number.withDefault(500),
    },
    setup: {
        title: 'Image zoomable',
    },
});

